export default __webpack_public_path__ + "static/media/frame5.b3d33d61.jpg";